import { EtherScanPictogram } from '@blockanalitica/ui';

type EtherscanLinkProps = {
  value: string;
  network?: string;
  type?: 'tx' | 'address';
};

const urlMap: Record<string, string> = {
  ethereum: 'https://etherscan.io/',
  arbitrum: 'https://arbiscan.io/',
  base: 'https://basescan.org/',
  polygon: 'https://polygonscan.com/',
  optimism: 'https://optimistic.etherscan.io/',
  scroll: 'https://scrollscan.com/'
};

export default function EtherscanLink({
  value,
  network,
  type = 'tx'
}: EtherscanLinkProps) {
  return (
    <a
      href={`${urlMap[network || 'ethereum']}${type}/${value}`}
      target="_blank"
      rel="noreferrer">
      <EtherScanPictogram size="0" />
    </a>
  );
}
